<template>
  <div class="observer"></div>
</template>

<script>
export default {
  name: 'observer',
  data: () => ({
    observer: null
  }),
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit('change', { intersecting: true })
      } else {
        this.$emit('change', { intersecting: false })
      }
    })
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    this.observer.disconnect()
  }
}
</script>
